import * as React from 'react';
import { observer } from "mobx-react";

import { AllotmentRangeDailyController } from 'src/app/products/allotment-range-daily/list/allotment-range-daily-list.controller';
import { AllotmentRangeDailyListDataService } from "src/app/products/allotment-range-daily/list/allotment-range-daily-list.data";
import { CardController } from "src/app/shared/card.controller";

interface AllotmentRangeAllotmentRangeDailyViewProps extends ComponentViewProps<AllotmentRangeItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
}

@observer
export class AllotmentRangeAllotmentRangeDailyView extends React.Component<AllotmentRangeAllotmentRangeDailyViewProps, any> {
	public render() {
		const { model, mode, onModeChanged, setBusy, contextService } = this.props;
		if (model == null) {
			return null;
		}

		return (
			<CardController
				icon="book"
				title="Allotment Range Daily information"
				className="card-borderless"
				mode={mode}
			>
				<AllotmentRangeDailyController
					mode={mode}
					onModeChanged={onModeChanged}
					model={model}
					setBusy={setBusy}
					contextService={contextService}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment-range/form/parts/allotmentrange-daily.view.tsx